import { Primitive as e } from "@radix-ui/react-primitive";
import * as r from "react";
import t from "@babel/runtime/helpers/esm/extends";
export const VisuallyHidden = /*#__PURE__*/r.forwardRef((i, o) => /*#__PURE__*/r.createElement(e.span, t({}, i, {
  ref: o,
  style: {
    ...i.style,
    position: "absolute",
    border: 0,
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    wordWrap: "normal"
  }
}))); /*#__PURE__*/
export const Root = VisuallyHidden;